(function () {
  'use strict';
  if (window.__ziqInit) return;
  window.__ziqInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Rotating hero words ---------- */
  function initRotate() {
    if (reduced) return;
    document.querySelectorAll('[data-ziq-rotate]').forEach(function (container) {
      var words = Array.prototype.slice.call(container.querySelectorAll('.ziq-rotate__word'));
      if (words.length < 2) return;
      var interval = parseInt(container.getAttribute('data-interval'), 10) || 2200;
      var current = 0;
      words.forEach(function (w, i) {
        w.classList.toggle('is-active', i === 0);
        w.classList.remove('is-out');
        w.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      });
      setInterval(function () {
        var prev = words[current];
        current = (current + 1) % words.length;
        var next = words[current];
        prev.classList.remove('is-active');
        prev.classList.add('is-out');
        prev.setAttribute('aria-hidden', 'true');
        next.classList.remove('is-out');
        void next.offsetWidth;
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
        setTimeout(function () {
          if (!prev.classList.contains('is-active')) prev.classList.remove('is-out');
        }, 700);
      }, interval);
    });
  }

  /* ---------- Hero intro choreography ---------- */
  function initHeroIntro() {
    if (reduced) return;
    var content = document.querySelector('.ziq-hero__content');
    if (content) {
      Array.prototype.slice.call(content.children).forEach(function (child, i) {
        child.classList.add('ziq-intro');
        child.style.animationDelay = (120 + i * 130) + 'ms';
      });
    }
    var media = document.querySelector('.ziq-hero__media');
    if (media) media.classList.add('ziq-intro-media');
  }

  /* ---------- Scroll progress bar ---------- */
  function initProgress() {
    var bar = document.createElement('div');
    bar.className = 'ziq-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Sumi-e brush underline ---------- */
  function initBrush() {
    var heads = document.querySelectorAll('.ziq-discover__head .ziq-h2,.ziq-range__head .ziq-h2,.ziq-features__head .ziq-h2,.ziq-layers__head .ziq-h2,.ziq-reviews__head .ziq-h2,.ziq-compare__head .ziq-h2');
    var ns = 'http://www.w3.org/2000/svg';
    heads.forEach(function (h) {
      if (h.querySelector('.ziq-brush')) return;
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('class', 'ziq-brush');
      svg.setAttribute('viewBox', '0 0 220 14');
      svg.setAttribute('aria-hidden', 'true');
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', 'M4 9 C 40 3, 92 12, 132 7 S 202 5, 216 8');
      svg.appendChild(p);
      h.appendChild(svg);
    });
  }

  /* ---------- Tategaki character stagger ---------- */
  function initChars() {
    if (reduced) return;
    document.querySelectorAll('[data-ziq-chars]').forEach(function (el) {
      var text = el.textContent.trim();
      if (!text) return;
      el.textContent = '';
      text.split('').forEach(function (ch, i) {
        var s = document.createElement('span');
        s.className = 'ziq-char';
        s.style.transitionDelay = (200 + i * 160) + 'ms';
        s.textContent = ch;
        el.appendChild(s);
      });
    });
  }

  /* ---------- Sakura petals (dense, layered depth) ---------- */
  function initSakura() {
    if (reduced) return;
    document.querySelectorAll('[data-ziq-sakura]').forEach(function (box) {
      var count = parseInt(box.getAttribute('data-count'), 10) || 22;
      for (var i = 0; i < count; i++) {
        var depth = i % 3 === 0 ? 'near' : (i % 3 === 1 ? 'mid' : 'far');
        var petal = document.createElement('div');
        petal.className = 'ziq-sakura__petal ziq-sakura__petal--' + depth;
        petal.style.left = (Math.random() * 104 - 2) + '%';
        var dur = depth === 'near' ? 9 + Math.random() * 5 : depth === 'mid' ? 13 + Math.random() * 6 : 17 + Math.random() * 7;
        petal.style.setProperty('--d', dur + 's');
        petal.style.setProperty('--delay', (-Math.random() * 24) + 's');
        var inner = document.createElement('div');
        inner.className = 'ziq-sakura__inner';
        inner.style.animationDuration = (2.2 + Math.random() * 2.2) + 's';
        var s = depth === 'near' ? 15 + Math.random() * 7 : depth === 'mid' ? 11 + Math.random() * 5 : 8 + Math.random() * 4;
        inner.style.width = s + 'px';
        inner.style.height = s + 'px';
        petal.appendChild(inner);
        box.appendChild(petal);
      }
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var selectors = [
      '.ziq-hero__content','.ziq-hero__media',
      '.ziq-discover__head','.ziq-dcard',
      '.ziq-offer__content','.ziq-offer__media',
      '.ziq-pay__text','.ziq-pay__icons',
      '.ziq-range__head','.ziq-tile',
      '.ziq-features__head','.ziq-frow__media','.ziq-frow__content',
      '.ziq-compare__head','.ziq-plan',
      '.ziq-reviews__head',
      '.ziq-reviews__grid .ziq-review',
      '.ziq-personalize__content','.ziq-personalize__media',
      '.ziq-stats__head','.ziq-stat',
      '.ziq-layers__head','.ziq-layers__content','.ziq-layers__visual',
      '.ziq-story__content','.ziq-story__media','.ziq-story__tategaki',
      '.ziq-enso'
    ];
    var els = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('ziq-reveal'); });
    ['.ziq-discover__grid', '.ziq-range__grid', '.ziq-compare__grid', '.ziq-reviews__grid', '.ziq-stats__grid'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (parent) {
        Array.prototype.slice.call(parent.children).forEach(function (child, i) {
          if (child.classList.contains('ziq-reveal')) {
            child.style.transitionDelay = Math.min(i * 70, 350) + 'ms';
          }
        });
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ziq-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
        el.classList.add('ziq-in');
      } else {
        io.observe(el);
      }
    });
    /* Safety sweep: reveal anything in view that the observer missed
       (zero-height media, clip-path quirks, lazy-loaded images). */
    var sweeping = false;
    function sweep() {
      sweeping = false;
      els.forEach(function (el) {
        if (el.classList.contains('ziq-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.95 && r.bottom > -10) {
          el.classList.add('ziq-in');
          io.unobserve(el);
        }
      });
    }
    function requestSweep() {
      if (!sweeping) { sweeping = true; requestAnimationFrame(sweep); }
    }
    window.addEventListener('load', requestSweep);
    window.addEventListener('scroll', requestSweep, { passive: true });
    window.addEventListener('resize', requestSweep);
    setTimeout(requestSweep, 1200);
    setTimeout(requestSweep, 3000);
  }

  /* ---------- Count-up stats ---------- */
  function initCount() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-ziq-count]'));
    if (!els.length) return;
    function finalText(el) {
      var target = parseFloat(el.getAttribute('data-ziq-count')) || 0;
      var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
      return dec > 0 ? target.toFixed(dec) : Math.round(target).toLocaleString('en-US');
    }
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = finalText(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-ziq-count')) || 0;
        var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = dec > 0 ? val.toFixed(dec) : Math.round(val).toLocaleString('en-US');
          if (p < 1) requestAnimationFrame(step); else el.textContent = finalText(el);
        }
        el.textContent = dec > 0 ? (0).toFixed(dec) : '0';
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Scroll parallax ---------- */
  function initParallax() {
    if (reduced) return;
    document.querySelectorAll('.ziq-hero__media img').forEach(function (img) {
      if (!img.hasAttribute('data-ziq-parallax')) img.setAttribute('data-ziq-parallax', '0.05');
    });
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-ziq-parallax]'));
    if (!items.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-ziq-parallax')) || 0.05;
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Layer explorer ---------- */
  function initLayers() {
    document.querySelectorAll('[data-ziq-layers]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.ziq-layer-item'));
      var bars = Array.prototype.slice.call(root.querySelectorAll('.ziq-layer-bar'));
      if (!items.length) return;
      function activate(i) {
        items.forEach(function (el, j) { el.classList.toggle('is-active', i === j); });
        bars.forEach(function (el, j) { el.classList.toggle('is-active', i === j); });
      }
      items.forEach(function (el, i) {
        el.addEventListener('mouseenter', function () { activate(i); });
        el.addEventListener('click', function () { activate(i); });
        el.addEventListener('focus', function () { activate(i); });
      });
      bars.forEach(function (el, i) {
        el.addEventListener('mouseenter', function () { activate(i); });
      });
      activate(0);
    });
  }

  /* ---------- Sticky quick-shop bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-ziq-sticky]');
    if (!bar) return;
    try { if (sessionStorage.getItem('ziqStickyClosed')) return; } catch (e) {}
    var closeBtn = bar.querySelector('.ziq-sticky__close');
    var shown = false;
    function onScroll() {
      var nearBottom = (window.innerHeight + window.scrollY) > (document.documentElement.scrollHeight - 500);
      var should = window.scrollY > 700 && !nearBottom;
      if (should !== shown) { shown = should; bar.classList.toggle('is-visible', shown); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.remove('is-visible');
        try { sessionStorage.setItem('ziqStickyClosed', '1'); } catch (e) {}
        window.removeEventListener('scroll', onScroll);
      });
    }
  }

  function init() {
    initRotate();
    initHeroIntro();
    initProgress();
    initBrush();
    initChars();
    initSakura();
    initReveal();
    initCount();
    initParallax();
    initLayers();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
